/* eslint-disable react/destructuring-assignment */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkIcon } from 'uitk-react-icons';
import * as React from 'react';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
var HeaderMenu = /** @class */ (function (_super) {
    __extends(HeaderMenu, _super);
    function HeaderMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        return _this;
    }
    HeaderMenu.prototype.toggleMenu = function () {
        var isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        });
    };
    HeaderMenu.prototype.render = function () {
        return (React.createElement(UitkMenu, { isOpen: this.state.isOpen, onTriggerClick: this.toggleMenu },
            React.createElement(UitkMenuTrigger, null,
                React.createElement(UitkTertiaryButton, { className: "custom-trigger-class global-navigation-nav-button", size: UitkButtonSize.LARGE },
                    React.createElement(UitkIcon, { name: "menu", title: "menu", id: "menu-icon" }))),
            React.createElement(UitkMenuContainer, { position: PositionType.LEFT },
                React.createElement(UitkMenuList, { items: this.props.menuItems }))));
    };
    return HeaderMenu;
}(React.Component));
export { HeaderMenu };
//# sourceMappingURL=header-menu.js.map